<script setup>
import { computed, defineProps } from "vue";

const props = defineProps({
  fontSize: {
    type: String,
    default: "30px",
  },
  label: {
    type: String,
    default: "Loading...",
  },
  steps: {
    type: Number,
    default: 11,
  }
});

const fontSize = computed(() => props.fontSize);
const label = computed(() => props.label);
const steps = computed(() => props.steps);
</script>
<template>
  <div class="loader-text" v-bind="$attrs" :data-label="label"></div>
</template>

<style lang="css">
.loader-text {
  width: fit-content;
  font-weight: bold;
  font-size: v-bind(fontSize);
  clip-path: inset(0 100% 0 0);
  animation: l5 2s steps(v-bind(steps)) infinite;
}
.loader-text:before {
  content: attr(data-label);
}
@keyframes l5 {
  to {
    clip-path: inset(0 -1ch 0 0);
  }
}
</style>
